import {ADD_MESSAGE, REMOVE_MESSAGE} from '../constants/actionTypes';

export function addMessage(action, bet) {
    let message = {
        action: undefined,
        bet: undefined
    }

    return {type: ADD_MESSAGE, message};
}

export function removeMessage() {
    return {type: REMOVE_MESSAGE};
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/actions/messageBarActions.js